import React from "react";
import { Box, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { Message2 } from "iconsax-react";

// Follows BlockedContactBox.jsx's exact layout convention (icon + title + subtitle,
// no button — there's genuinely no action available here, unlike ExpiredServiceBox's
// "send a template instead"). Shown in place of the compose box when the only outbound
// message Meta's Private Reply API allows for a comment-only contact has already been
// sent and they haven't replied yet (see TextBox.jsx's awaitingCommentReply).
const AwaitingCommentReplyBox = ({ contactName }) => {
  return (
    <Box
      sx={{
        backgroundColor: (theme) =>
          theme.palette.mode === "dark" ? alpha(theme.palette.info.main, 0.12) : "#dceefd",
        border: (theme) =>
          theme.palette.mode === "dark"
            ? `1px solid ${alpha(theme.palette.info.light, 0.35)}`
            : `1px solid ${alpha("#0c3f61", 0.12)}`,
        borderRadius: "12px",
        padding: { xs: "16px 18px", sm: "20px 24px" },
        display: "flex",
        alignItems: "center",
        gap: "10px",
        maxWidth: { xs: "95%", sm: "90%", md: "85%", lg: "80%" },
        margin: "auto",
        mb: { xs: "8px", sm: "12px", md: "20px" },
        boxShadow: (theme) =>
          theme.palette.mode === "dark"
            ? `0 2px 12px ${alpha("#000", 0.35)}`
            : "0 2px 8px rgba(0,0,0,0.08)",
      }}
    >
      <Box
        sx={{
          width: 22,
          height: 22,
          flexShrink: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: (theme) => (theme.palette.mode === "dark" ? theme.palette.info.light : "#0c3f61"),
        }}
      >
        <Message2 size="100%" variant="Linear" color="currentColor" />
      </Box>
      <Box sx={{ minWidth: 0 }}>
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: "0.875rem",
            lineHeight: 1.3,
            color: (theme) => (theme.palette.mode === "dark" ? theme.palette.text.primary : "#0c3f61"),
          }}
        >
          Waiting for a reply
        </Typography>
        <Typography
          sx={{
            fontSize: "0.8125rem",
            lineHeight: 1.4,
            mt: "3px",
            color: (theme) =>
              theme.palette.mode === "dark" ? alpha(theme.palette.common.white, 0.78) : alpha("#0c3f61", 0.92),
          }}
        >
          {contactName
            ? `You've sent your reply to this comment — ${contactName} needs to reply before you can send another message.`
            : "You've sent your reply to this comment — they need to reply before you can send another message."}
        </Typography>
      </Box>
    </Box>
  );
};

export default AwaitingCommentReplyBox;
